import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import ReduxRecord from './reduxRecord';
import { getSessionItemById } from '../selectors/sessionItems';
export var QuizSessionEvent = /*#__PURE__*/function (_ReduxRecord) {
  function QuizSessionEvent() {
    _classCallCheck(this, QuizSessionEvent);
    return _callSuper(this, QuizSessionEvent, arguments);
  }
  _inherits(QuizSessionEvent, _ReduxRecord);
  return _createClass(QuizSessionEvent, [{
    key: "isLoaded",
    value: function isLoaded() {
      return !!this.get('createdAt');
    }
  }, {
    key: "createdDate",
    value: function createdDate() {
      return new Date(this.get('createdAt').split('|')[0]);
    }
  }, {
    key: "getSessionItem",
    value: function getSessionItem() {
      var sessionItemPosition = Math.round(this.getIn(['eventData', 'position']));
      var sessionItemKey = "".concat(this.quizSessionId, "_").concat(sessionItemPosition);
      return getSessionItemById(this.getState(), sessionItemKey);
    }
  }, {
    key: "getItem",
    value: function getItem() {
      return this.getSessionItem().getItem();
    }
  }]);
}(ReduxRecord({
  createdAt: null,
  eventType: null,
  eventData: null,
  quizSessionId: null
}));
export default QuizSessionEvent;